import * as angular from 'angular';
import ConfirmDirective from './ConfirmDirective';
import ConfirmFactory from './ConfirmFactory';
import ConfirmModalController from './ConfirmModalController';

export default angular.module('dataforvalter.confirm', [])
    .controller('ConfirmModalController', ConfirmModalController)
    .value('$confirmModalDefaults', {
        template: '<div class="modal-header"><h3 class="modal-title">Bekreft operasjon</h3></div><div class="modal-body">{{data.text}}</div><div class="modal-footer"><button class="btn btn-primary" ng-click="ok()">OK</button><button class="btn btn-warning" ng-click="cancel()">Avbryt</button></div>',
        controller: 'ConfirmModalController'
    })
    .factory('$confirm', ConfirmFactory)
    .directive('confirm', ConfirmDirective)
    .name;
